/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Menuscanerrorunsupported3Inputs */

const en_menuscanerrorunsupported3 = /** @type {(inputs: Menuscanerrorunsupported3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A file has a format we cannot read. JPEG, PNG, WebP and PDF work.`)
};

const de_menuscanerrorunsupported3 = /** @type {(inputs: Menuscanerrorunsupported3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Eine Datei hat ein Format, das wir nicht lesen können. Erlaubt sind JPEG, PNG, WebP und PDF.`)
};

/**
* | output |
* | --- |
* | "A file has a format we cannot read. JPEG, PNG, WebP and PDF work." |
*
* @param {Menuscanerrorunsupported3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const menuscanerrorunsupported3 = /** @type {((inputs?: Menuscanerrorunsupported3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Menuscanerrorunsupported3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_menuscanerrorunsupported3(inputs)
	return de_menuscanerrorunsupported3(inputs)
});
export { menuscanerrorunsupported3 as "menuScanErrorUnsupported" }